<template>
  <div v-if="modalOpened" class="modal">
    <div class="modal-bg" @click="$emit('close', false)"></div>
    <div class="p-6">
      <div class="modal-inner">
        <div
          @click="$emit('close', false)"
          class="
            w-8
            h-8
            absolute
            modal-close-btn
            flex
            item
            justify-center
            rounded-full
            bg-gray-100
            cursor-pointer
          "
        >
          <i class="fas fa-times text-gray-700 mt-2"></i>
        </div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["modalOpened"],
};
</script>

<style scoped>
.modal-close-btn {
  right: -10px;
  top: -10px;
  z-index: 1;
}

.modal {
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  display: grid;
  place-content: center;
}

.modal .modal-inner {
  height: max-content;
  width: 70vw;
  /* border-radius: 10px; */
  /* background-color: #fff; */
  position: relative;
  z-index: 101;
}

.modal .modal-bg {
  background-color: #212121dd;

  height: 100vh;
  width: 100vw;
  position: absolute;
  z-index: 100;
  top: 0;
  left: 0;
}
@media (max-width: 768px) {
  .modal .modal-inner {
    height: max-content;
    width: 88vw;
    /* border-radius: 10px; */
    /* background-color: #fff; */
    position: relative;
    z-index: 101;
  }
}
</style>